import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Complexity {
  id: string
  name: string
}

export interface UseComplexitiesResult {
  complexities: Complexity[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useComplexities(fetchOnMount = false): UseComplexitiesResult {
  const [complexities, setComplexities] = useState<Complexity[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ complexities: Complexity[] }>('/admin/conversation-management/complexities/dropdown')
      console.log('Complexities response:', res)
      setComplexities(res.complexities || [])
    } catch (e) {
      console.error('Failed to fetch complexities:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch complexities')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { complexities, loading, error, refetch }
}
